import { RouteObject } from 'react-router-dom'
import { lazy } from 'react'
import ModuleGuard from '@/core/guards/ModuleGuard.tsx'
import ErrorPage from '@/pages/errors/ErrorPage.tsx'

const SERVICES_ROUTES: RouteObject[] = [
  {
    path: 'services',
    element: <ModuleGuard />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'services',
        lazy: async () => {
          const ServicesPage = lazy(
            () => import('@/pages/services/services/ServicesPage.tsx')
          )
          return { element: <ServicesPage /> }
        }
      },
      {
        path: 'services/:id',
        lazy: async () => {
          const ServiceDetailsPage = lazy(
            () =>
              import('@/pages/services/serviceDetails/ServiceDetailsPage.tsx')
          )
          return { element: <ServiceDetailsPage /> }
        }
      },
      {
        path: 'daily-cut',
        lazy: async () => {
          const DailyCutPage = lazy(
            () => import('@/pages/services/dailyCut/DailyCutPage.tsx')
          )
          return { element: <DailyCutPage /> }
        }
      },
      {
        path: 'daily-cut/:id/:payallDailyCutId',
        lazy: async () => {
          const DailyCutDetailsPage = lazy(
            () =>
              import('@/pages/services/dailyCutDetails/DailyCutDetailsPage.tsx')
          )
          return { element: <DailyCutDetailsPage /> }
        }
      }
    ]
  }
]

export default SERVICES_ROUTES
